module.exports = __webpack_public_path__ + "static/subtitle_blue_stroke-f6a0a74a46ba34cd21863563251ae50a.svg";